import { useStrings } from "@1js/localization-components";
import { Tab, Text } from "@fluentui/react-components";
import React from "react";
import type { Appearance } from "../data";
import {
  GroupPromptsLabel,
  GroupPromptsLabelRockSteady,
} from "./PromptTab.strings";
import { PromptTabs } from "./PromptTabs";
import { useStyles } from "./Tab.styles";

export const TeamsTabTestId = "workgroup-prompts-tab";

type GroupTabProps = {
  isSelected: boolean;
  appearance: Appearance;
  isRocksteadyUxEnabled?: boolean;
};

export const GroupTab: React.FC<GroupTabProps> = ({
  isSelected,
  appearance,
  isRocksteadyUxEnabled,
}) => {
  const localizations = useStrings({
    GroupPromptsLabel,
    GroupPromptsLabelRockSteady,
  });

  const classes = useStyles(appearance)();
  return (
    <Tab
      aria-label={localizations.GroupPromptsLabel()}
      value={PromptTabs.GroupPrompts}
      data-testid={TeamsTabTestId}
      className={isSelected ? classes.selected : classes.tab}
    >
      <Text className={isSelected ? classes.selectedText : classes.text}>
        {isRocksteadyUxEnabled
          ? localizations.GroupPromptsLabelRockSteady()
          : localizations.GroupPromptsLabel()}
      </Text>
    </Tab>
  );
};
